// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CiOutlinedSvg from "@ant-design/icons-svg/es/asn/CiOutlined";
import AntdIcon from '../components/AntdIcon';

var CiOutlined = function CiOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CiOutlinedSvg
  }));
};

CiOutlined.displayName = 'CiOutlined';
export default React.forwardRef(CiOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CiOutlined.js
// module id = 771
// module chunks = 0